/**
 * Generates a unique key for a given file based on its name, size, and last modified timestamp.
 *
 * @param {File} file - The file for which to generate the key.
 * @returns {string} A unique key string composed of the file's name, size, and last modified time.
 */

export const generateFileKey = (file: File) => {
    return `${file.name}-${file.size}-${file.lastModified}`;
};
